<script setup lang="ts">
import { ref } from 'vue';
import { BaseCheckbox } from 'src/shared/ui';
import styles from './styles.module.css';
import { openDownload } from 'src/logic/functions/open-download.function';

export interface TermsTextProps {
  policyLink?: string;
  userAgreementsLink?: string;
  consentLink?: string;
  cb?: (v: boolean) => void;
}

const props = withDefaults(defineProps<TermsTextProps>(), {
  policyLink: '#',
  consentLink: '#',
  cb: () => {},
});

const policyChecked = ref(false);
const consentChecked = ref(false);
const userAgreementsChecked = ref(false);

// function openDownload(url?: string): void {
//   if (!url) return;
//   window.open(url, '_blank', 'noopener,noreferrer');
// }

function handleCheckboxChange(
  checkbox: 'policy' | 'consent' | 'userAgreements',
  value: boolean,
): void {
  if (checkbox === 'policy') {
    policyChecked.value = value;
  } else if (checkbox === 'consent') {
    consentChecked.value = value;
  } else if (checkbox === 'userAgreements') {
    userAgreementsChecked.value = value;
  }

  const allChecked = policyChecked.value && consentChecked.value && userAgreementsChecked.value;
  props.cb(allChecked);
}
</script>

<template>
  <div :class="styles.agreementsContainer">
    <BaseCheckbox :cb="(v) => handleCheckboxChange('policy', v)">
      <p :class="styles.agreements">
        Проставляя электронную отметку в данном поле, я подтверждаю, что ознакомился с
        <a :href="props.policyLink" @click.prevent="openDownload(props.policyLink)">Политикой обработки персональных данных
        </a>
      </p>
    </BaseCheckbox>
    <BaseCheckbox :cb="(v) => handleCheckboxChange('consent', v)">
      <p :class="styles.agreements">
        Проставляя электронную отметку в данном поле, я подтверждаю, что
        <a :href="props.consentLink" @click.prevent="openDownload(props.consentLink)">Согласие на обработку моих персональных данных</a>
        является конкретным, предметным, информированным, однозначным, данным лично мной добровольно
      </p>
    </BaseCheckbox>
    <BaseCheckbox :cb="(v) => handleCheckboxChange('userAgreements', v)">
      <p :class="styles.agreements">
        Проставляя электронную отметку в данном поле, я подтверждаю, что ознакомился с
        <a :href="props.userAgreementsLink" @click.prevent="openDownload(props.userAgreementsLink)">Пользовательским соглашением</a>
        и принимаю условия
      </p>
    </BaseCheckbox>
  </div>
</template>
